export function PublicContactPanel({
  address = "",
  email = "",
  phone = "",
  workspaceLabel = "range"
}) {
  if (!address && !email && !phone) {
    return null;
  }

  return (
    <div className="public-contact-panel" id="contact">
      {email && <a href={`mailto:${email}`}>Email {workspaceLabel}</a>}
      {phone && <a href={`tel:${phone}`}>Call {workspaceLabel}</a>}
      {address && (
        <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`} target="_blank" rel="noreferrer">
          Directions
        </a>
      )}
      {address && <span>{address}</span>}
    </div>
  );
}
